export default __webpack_public_path__ + "static/media/SegoeUI.45472284.ttf";